import axiosInstance from './axios-instance';

export type ExplainSelectionBody = {
  articleId: string;
  highlightedText: string;
  provider: string;
  userPrompt: string;
};

export type FactCheckBody = {
  provider: string;
  prompt: string;
  articleId: string;
};

export type GetInitializationFactCheckBody = {
  articleId: string;
};

export type ConserveBody = {
  articleId: string;
  message: string;
};

export const explainSelection = async (data: ExplainSelectionBody) => {
  const result = await axiosInstance.post(`api/v1/ai/llm/explain`, data);
  return result.data;
};

export const getInitializationFactCheck = async (data: GetInitializationFactCheckBody) => {
  const result = await axiosInstance.get(`/api/v1/ai/llm/fact-check?articleId=${data.articleId}`);
  return result.data;
};

export const factCheck = async (data: FactCheckBody) => {
  const result = await axiosInstance.post(`/api/v1/ai/llm/fact-check`, data);
  return result.data;
};

export const conserve = async (data: ConserveBody) => {
  const result = await axiosInstance.post(`/api/v1/ai/llm/conserve`, data);
  return result.data;
};
